import { NodeSet } from './NodeSet.js';
//TODO: test performance of QuadArray vs QuadSet and probably remove QuadArray
export class QuadArray extends Array {
    removeAll(alteration = false) {
        this.forEach((quad) => quad.remove(alteration));
    }
    moveTo(graph, alteration = true) {
        let result = new QuadArray();
        this.forEach((quad) => {
            result.push(quad.moveToGraph(graph, alteration));
        });
        return result;
    }
    makeExplicit() {
        this.forEach((quad) => quad.makeExplicit());
    }
    getSubjects() {
        //return new NamedNodeSet(this.map(quad => quad.subject).values());
        //that's short, but probably this is faster:
        var res = new NodeSet();
        for (var quad of this) {
            res.add(quad.subject);
        }
        return res;
    }
    getPredicates() {
        var res = new NodeSet();
        for (var quad of this) {
            res.add(quad.predicate);
        }
        return res;
    }
    getObjects() {
        var res = new NodeSet();
        for (var quad of this) {
            res.add(quad.object);
        }
        return res;
    }
    map(callbackfn) {
        return super.map(callbackfn);
    }
    getExplicit() {
        return this.filter((quad) => !quad.implicit);
    }
    getImplicit() {
        return this.filter((quad) => quad.implicit);
    }
    turnOn() {
        this.forEach((quad) => quad.turnOn());
    }
    turnOff() {
        this.forEach((quad) => quad.turnOff());
    }
    toString() {
        //without this the toString() would print 3 URI's for each quad followed by a ',' which looks messy and unclear
        return this.join('\n');
    }
    print() {
        console.log(this.toString());
    }
}
//# sourceMappingURL=QuadArray.js.map